// import request from 'utils/request';

// export default async function fetchPartNumbers(body: any): Promise<any> {
//   try {
//     const result = await request(`/salesData/getPartNumbers`, {
//       method: 'GET',
//       body
//     });

//     return result;
//   } catch (error) {
//     console.log(error.message);
//   }
// }

import request from 'utils/request';

export default async function fetchPartNumbers(rep): Promise<any> {
  try {
    const result = await request(`/lineDriveService/salesData/getPartNumbers`, {
      method: 'GET',
      body: {
        repName: rep
      }
    });

    return result;
  } catch (error) {
    console.log(error.message);
  }
}
